import React, { useState, useEffect } from 'react'
import {
  Panel,
  InputNumber,
  Grid,
  Row,
  Col,
  Input,
  InputGroup,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  SelectPicker,
  IconButton,
  Icon,
  RadioGroup,
  Radio,
  Table,
  CheckboxGroup,
  Checkbox,
  Button,
} from 'rsuite'
import { requiredFiled, isValidators } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../CustomIconMessageInfo'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import InputForm from '../../../../components/forms/input/InputForm'
import InputNumberForm from '../../../../components/forms/input/InputNumberForm'
import { set } from 'lodash-es'

export default function BackgroundExerciseActivityForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
}) {
  const { Column, HeaderCell, Cell } = Table
  const [shopPerActs, setShopPerActs] = useState([])
  const [shopAmount, setShopAmount] = useState(0)

  useEffect(() => {
    // acts.
  }, [schema])

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            <Col style={{ marginTop: '1em' }}>{schema.communityInfo.label}</Col>
            <CustomIconMessageInfo contents={schema.communityInfo.description} />

            <Col style={{ marginTop: '1em' }}>
              <b>{schema.numOfPopulation.label}</b>
            </Col>

            <Row style={{ marginLeft: '1rem' }}>
              <Col xs={24} sm={24} md={10} lg={10}>
                <InputNumberForm
                  schema={schema.childhood}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  labelMdLg={12}
                  inputMdlg={12}
                />
              </Col>
              <Col xs={24} sm={24} md={14} lg={14}>
                <InputForm
                  schema={schema.childhoodBehavior}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            </Row>
            <Row style={{ marginLeft: '1rem' }}>
              <Col xs={24} sm={24} md={10} lg={10}>
                <InputNumberForm
                  schema={schema.workingAge}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  labelMdLg={12}
                  inputMdlg={12}
                />
              </Col>
              <Col xs={24} sm={24} md={14} lg={14}>
                <InputForm
                  schema={schema.workingAgeBehavior}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            </Row>
            <Row style={{ marginLeft: '1rem' }}>
              <Col xs={24} sm={24} md={10} lg={10}>
                <InputNumberForm
                  schema={schema.oldAge}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  labelMdLg={12}
                  inputMdlg={12}
                />
              </Col>
              <Col xs={24} sm={24} md={14} lg={14}>
                <InputForm
                  schema={schema.oldAgeBehavior}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            </Row>

            <CKEditorFrom
              schema={schema.healthProblems}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Row>

          <InputForm
            schema={schema.artsAndCulture}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            labelMdLg={8}
            inputMdlg={16}
          />

          <Row>
            <CKEditorFrom
              schema={schema.reason}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Row>

          <InputForm
            schema={schema.activityArea}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            labelMdLg={8}
            inputMdlg={16}
          />
        </Grid>
      </Panel>
    </>
  )
}
